import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters, boName }) => {
    const { natureDeviationReason, natureDeviationReasonGroup } = useReportFiltersFetch({ fetchNatureDeviationReason: true, fetchNatureDeviationReasonGroup: true })

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label={`${boName}`}
                        isMulti={false}
                        options={[
                            {label: "Todos", value: 'all'},
                            {label: `Com ${boName}`, value: 'WITH_BOGCM'},
                            {label: `Sem ${boName}`, value: 'WITHOUT_BOGCM'}
                        ]}
                        value={filters.bo}
                        onChange={(value) => setFilters(prev => ({...prev, bo: value}))}
                        instanceId="bo"
                        classNameWrapper={"w-full"}
                        isClearable={false}
                    />

                    <SelectComponent
                        label='Natureza'
                        isMulti={true}
                        wrapValues={true}
                        options={natureDeviationReason}
                        value={filters.nature}
                        onChange={(value) => setFilters(prev => ({...prev, nature: value}))}
                        instanceId="reason"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Grupo de natureza'
                        isMulti={true}
                        wrapValues={true}
                        options={natureDeviationReasonGroup}
                        value={filters.nature_group}
                        onChange={(value) => setFilters(prev => ({...prev, nature_group: value}))}
                        instanceId="group_reason"
                        classNameWrapper={"w-full"}
                    />

                    <InputCheckbox
                        id="showDescription"
                        label="Exibir descrição"
                        className={'ml-1'}
                        checked={filters.showDescription}
                        onChange={(e) => setFilters(prev => ({...prev, showDescription: e.target.checked}))}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;